import React, { Component, Fragment } from 'react';
import {
    ListGroup,
    ListGroupItem
} from 'reactstrap';
import MaterialIcon from 'material-icons-react';
import i18n from '../../../i18next';

import {
    ADDITIONAL,
    ALLERGENS,
    DIETARY,
    NUTRIENTS,
    AVAILABILITY,
    MENU_ITEM_SUB_ANSWER,
    MENU_ITEM_TYPE_ANSWER
} from '../../../utils/Constants';

class ExtraInfoRows extends Component {

    renderMoreInformation(currentScreen, screenTwo, screenThree, screenFour, screenFive) { // true is hidden <---> 1 is the item being clicked
        let setStateObject = { ...this.props.state };

        if (this.props.state.modalSize && this.props.itemType !== MENU_ITEM_TYPE_ANSWER) {
            if (!this.props.state[`${currentScreen}Info`]) { // 1 = false - when one is open sets the other two to true
                setStateObject[`${currentScreen}Info`] = !this.props.state[`${currentScreen}Info`];
                setStateObject[`${currentScreen}ArrowIcon`] = !this.props.state[`${currentScreen}ArrowIcon`];

                setStateObject[`${screenTwo}Info`] = true;
                setStateObject[`${screenTwo}ArrowIcon`] = true;

                setStateObject[`${screenThree}Info`] = true;
                setStateObject[`${screenThree}ArrowIcon`] = true;

                setStateObject[`${screenFour}Info`] = true;
                setStateObject[`${screenFour}ArrowIcon`] = true;

                setStateObject[`${screenFive}Info`] = true;
                setStateObject[`${screenFive}ArrowIcon`] = true;
                setStateObject.modalSize = !this.props.state.modalSize;
            } else if (this.props.state[`${currentScreen}Info`]) { // 1 = true and item has already been opened
                setStateObject[`${currentScreen}Info`] = !this.props.state[`${currentScreen}Info`];
                setStateObject[`${currentScreen}ArrowIcon`] = !this.props.state[`${currentScreen}ArrowIcon`];

                setStateObject[`${screenTwo}Info`] = true;
                setStateObject[`${screenTwo}ArrowIcon`] = true;

                setStateObject[`${screenThree}Info`] = true;
                setStateObject[`${screenThree}ArrowIcon`] = true;

                setStateObject[`${screenFour}Info`] = true;
                setStateObject[`${screenFour}ArrowIcon`] = true;

                setStateObject[`${screenFive}Info`] = true;
                setStateObject[`${screenFive}ArrowIcon`] = true;
            }
        } else {
            setStateObject[`${currentScreen}Info`] = !this.props.state[`${currentScreen}Info`];
            setStateObject[`${currentScreen}ArrowIcon`] = !this.props.state[`${currentScreen}ArrowIcon`];
            setStateObject.modalSize = !this.props.state.modalSize;
        }

        this.props.modifyExtraRowsState(setStateObject);
    }

    render() {
        const { listGroupItem, alignRight } = styles;

        let colSize = 12;
        let additionalArrowIcon = 'keyboard_arrow_right';
        let additionalActiveInfo = "";
        let additionalIconColor = '#000';

        let allergensArrowIcon = 'keyboard_arrow_right';
        let allergensActiveInfo = '';
        let allergensIconColor = '#000';

        let dietaryInfoArrowIcon = 'keyboard_arrow_right';
        let dietaryActiveInfo = '';
        let dietaryIconColor = '#000';

        let nutrientsArrowIcon = 'keyboard_arrow_right';
        let nutrientsActiveInfo = '';
        let nutrientsIconColor = '#000';

        let availabilityInfoArrowIcon = 'keyboard_arrow_right';
        let availabilityActiveInfo = '';
        let availabilityIconColor = '#000';
        if (this.props.itemType !== MENU_ITEM_TYPE_ANSWER) {
            if (this.props.state.modalSize === true) {
                if (!this.props.state.additionalInfo) {
                    colSize = 8;
                    additionalArrowIcon = 'keyboard_arrow_left';
                    additionalActiveInfo = 'active';
                    additionalIconColor = '#0288D1';
                }

                if (!this.props.state.allergensInfo) {
                    colSize = 8;
                    allergensArrowIcon = 'keyboard_arrow_left';
                    allergensActiveInfo = 'active';
                    allergensIconColor = '#0288D1';
                }

                if (!this.props.state.dietaryInfo) {
                    colSize = 8;
                    dietaryInfoArrowIcon = 'keyboard_arrow_left';
                    dietaryActiveInfo = 'active';
                    dietaryIconColor = '#0288D1';
                }

                if (!this.props.state.nutrientsInfo) {
                    colSize = 8;
                    nutrientsArrowIcon = 'keyboard_arrow_left';
                    nutrientsActiveInfo = 'active';
                    nutrientsIconColor = '#0288D1';
                }

                if (!this.props.state.availabilityInfo) {
                    colSize = 5;
                    availabilityInfoArrowIcon = 'keyboard_arrow_left';
                    availabilityActiveInfo = 'active';
                    availabilityIconColor = '#0288D1';
                }
            } else {
                if (!this.additionalInfo) {
                    colSize = 12;
                    additionalArrowIcon = 'keyboard_arrow_right';
                }

                if (!this.props.state.allergensInfo) {
                    colSize = 12;
                    allergensArrowIcon = 'keyboard_arrow_right';
                }

                if (!this.props.state.dietaryInfo) {
                    colSize = 12;
                    dietaryInfoArrowIcon = 'keyboard_arrow_right';
                }

                if (!this.props.state.nutrientsInfo) {
                    colSize = 12;
                    nutrientsArrowIcon = 'keyboard_arrow_right';
                }

                if (!this.props.state.availabilityInfo) {
                    colSize = 12;
                    availabilityInfoArrowIcon = 'keyboard_arrow_right';
                }
            }
        } else {
            if (this.props.state.modalSize) {
                colSize = 12;
                nutrientsArrowIcon = 'keyboard_arrow_left';
                nutrientsIconColor = '#0288D1';
            } else {
                colSize = 8;
                nutrientsArrowIcon = 'keyboard_arrow_right';
            }
        }


        return (
            <Fragment>
                {
                    this.props.itemType === MENU_ITEM_TYPE_ANSWER ? null :
                        <Fragment>
                            <ListGroup onClick={() => this.renderMoreInformation(ADDITIONAL, ALLERGENS, DIETARY, NUTRIENTS, AVAILABILITY)} flush>
                                <ListGroupItem style={listGroupItem} className={additionalActiveInfo}>{i18n.t('common:buttons.additionalInfo')}
                                    <span style={alignRight}><MaterialIcon icon={additionalArrowIcon} color={additionalIconColor} size={20} /></span>
                                </ListGroupItem>
                            </ListGroup>

                            <ListGroup onClick={() => this.renderMoreInformation(ALLERGENS, ADDITIONAL, DIETARY, NUTRIENTS, AVAILABILITY)} flush style={{ marginTop: 10 }}>
                                <ListGroupItem style={listGroupItem} className={allergensActiveInfo}>{i18n.t('screens:productScreen.allergens')}
                                    <span style={alignRight}><MaterialIcon icon={allergensArrowIcon} color={allergensIconColor} size={20} /></span>
                                </ListGroupItem>
                            </ListGroup>
                            <ListGroup onClick={() => this.renderMoreInformation(DIETARY, ADDITIONAL, ALLERGENS, NUTRIENTS, AVAILABILITY)} flush style={{ marginTop: 10 }}>
                                <ListGroupItem style={listGroupItem} className={dietaryActiveInfo}>{i18n.t('screens:productScreen.dietary')}
                                    <span style={alignRight}><MaterialIcon icon={dietaryInfoArrowIcon} color={dietaryIconColor} size={20} /></span>
                                </ListGroupItem>
                            </ListGroup>
                        </Fragment>
                }
                {
                    this.props.mealDealProduct ? null :
                    < ListGroup onClick={() => this.renderMoreInformation(NUTRIENTS, DIETARY, ADDITIONAL, ALLERGENS, AVAILABILITY)} flush style={{ marginTop: 10 }}>
                        <ListGroupItem style={listGroupItem} className={nutrientsActiveInfo}>{i18n.t('screens:productScreen.nutrients')}
                            <span style={alignRight}><MaterialIcon icon={nutrientsArrowIcon} color={nutrientsIconColor} size={20} /></span>
                        </ListGroupItem>
                    </ListGroup>
                }

                {
                    this.props.itemType === MENU_ITEM_TYPE_ANSWER ? null :
                        <ListGroup onClick={() => this.renderMoreInformation(AVAILABILITY, ADDITIONAL, ALLERGENS, DIETARY, NUTRIENTS)} flush style={{ marginTop: 10 }}>
                            <ListGroupItem style={listGroupItem} className={availabilityActiveInfo}>{i18n.t('screens:menuConfigScreen.availabilityHours')}
                                <span style={alignRight}><MaterialIcon icon={availabilityInfoArrowIcon} color={availabilityIconColor} size={20} /></span>
                            </ListGroupItem>
                        </ListGroup>
                }

            </Fragment >
        );
    }
}

export default ExtraInfoRows;

let styles = {
    listGroupItem: {
        display: 'flex',
        background: 'none',
        borderBottom: '1px solid #dee2e7',
        cursor: 'pointer',
        borderTop: 'none',
        paddingLeft: '0.2rem',
        paddingRight: 0,
        paddingTop: 0
    },
    alignRight: {
        marginLeft: 'auto'
    }
}


// WEBPACK FOOTER //
// ./src/components/restaurants/posmenu/ExtraInfoRows.js